import { Component, EventEmitter, Input, Output, HostListener} from '@angular/core';
import { Router } from '@angular/router';
import { InvoicesService } from '../../services/invoices.service';
import { InvoiceLinesService } from '../../services/invoice-lines.service';
import { MessageService } from 'primeng/components/common/messageservice';
import { Invoice } from '../../../models/invoice';
import { InvoiceLine } from '../../../models/invoice-line';
// import {CdkDragDrop, moveItemInArray, transferArrayItem} from '@angular/cdk/drag-drop';

@Component({
	selector: 'app-invoice-line-table',
	templateUrl: 'invoice-line-table.template.html'
})

export class InvoiceLineTableComponent
{

	get invoice(): Invoice
	{
		return this._invoice;
	}

	@Input()
	set invoice(invoice: Invoice)
	{
		this._invoice = invoice;
		this.onInvoiceChange.emit(invoice);
	}

	_invoice: Invoice;
	@Output() onInvoiceChange = new EventEmitter<Invoice>();

	/**
	 * InvoiceLineTableComponent constructor
	 *
	 * @param {InvoicesService} invoicesService
	 * @param {InvoiceLinesService} invoiceLinesService
	 * @param {Router} router
	 * @param {MessageService} messageService
	 */
	constructor(private invoicesService: InvoicesService,
	            private invoiceLinesService: InvoiceLinesService,
	            private router: Router,
	            private messageService: MessageService)
	{
	}


	drop(ev, invoiceRow) {
		ev.target.parentNode.style.padding = "0px 0px 0px 0px";
		ev.target.parentNode.style.backgroundColor = "white";

		if( invoiceRow == undefined ) { return; }

		var invoiceDrag = JSON.parse( ev.dataTransfer.getData("data") );

		var rowPosition = invoiceRow.position;

		if( invoiceDrag.position == rowPosition ) { return; }

		for (let invoiceLineIndex in this.invoice.invoiceLines)
		{
			if( this.invoice.invoiceLines[invoiceLineIndex].position <= rowPosition && invoiceDrag.position < rowPosition )
			{
				this.invoice.invoiceLines[invoiceLineIndex].position--;
			}
			else if( this.invoice.invoiceLines[invoiceLineIndex].position >= rowPosition  && invoiceDrag.position > rowPosition )
			{
				this.invoice.invoiceLines[invoiceLineIndex].position++;
			}
		}

		for (let invoiceLineIndex in this.invoice.invoiceLines)
		{
			if( this.invoice.invoiceLines[invoiceLineIndex].id == invoiceDrag.id )
			{
				this.invoice.invoiceLines[invoiceLineIndex].position = rowPosition;
			}
		}

		this.invoice.invoiceLines.sort( function( a, b) {
			if ( a.position < b.position ){ return -1; }
			if ( a.position > b.position ){ return 1; }
			return 0;
		} );

		for (let invoiceLine of this.invoice.invoiceLines)
		{
			this.invoiceLinesService.updateInvoiceLine(invoiceLine.id, invoiceLine).subscribe(
				data => {
				},
				err => {
					this.messageService.add({
						summary: 'Fout',
						detail: 'De factuurregel kon niet worden geupdate.',
						severity: 'error'
					});
				}
			);
		}
	}

	allowDrop(ev) {
		ev.target.parentNode.style.padding = "30px 0px 0px 0px";
		ev.target.parentNode.style.background = "#f5f5f5a3";
		ev.preventDefault();
	}

	dragleave(ev) {
		ev.target.parentNode.style.padding = "0px 0px 0px 0px";
		ev.target.parentNode.style.backgroundColor = "white";
	}

	drag(ev, invoice) {
		ev.dataTransfer.setData("data", JSON.stringify(invoice) );
	}

	/**
	 * Deletes an invoice line
	 *
	 * @param {number} id
	 *
	 * @return void
	 */
	deleteInvoiceLine(id: number)
	{
		this.invoiceLinesService.deleteInvoiceLine(id).subscribe(
			data => {
				this.refreshInvoiceLines();
				this.messageService.add({
					summary: 'Succes',
					detail: 'De factuurregel is verwijderd.',
					severity: 'success'
				});
			},
			err => {
				this.messageService.add({
					summary: 'Fout',
					detail: 'De factuur kon niet worden verwijderd.',
					severity: 'error'
				});
			}
		);
	}

	/**
	 * Redirect to the InvoiceLine edit page
	 *
	 * @param {InvoiceLine} invoiceLine
	 *
	 * @return void
	 */
	editInvoiceLine(invoiceLine: InvoiceLine)
	{
		this.router.navigate(['facturen/' + invoiceLine.invoice_id + '/regel/' + invoiceLine.id]);
	}

	/**
	 * Retrieves the current invoice lines
	 *
	 * @return void
	 */
	refreshInvoiceLines()
	{
		this.invoicesService.getInvoice(this.invoice.id).subscribe(
			data => {
				this.invoice = data;
			}
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/invoices/invoice-detail/invoice-line/invoice-line-table.component.ts